import React from 'react'
import TwoColWrapper from '../technical/TwoColWrapper'
import Link from '../atoms/Link'

const TextWithListBlock = ({ block }) => {
  return (
    <TwoColWrapper className="text-with-list-block" block={block}>
      {block.list_headline?.length > 0 && (
        <h2 className="h3-headline">
          <span>{block.list_headline}</span>
        </h2>
      )}
      <ul className="kn-feature-list">
        {block.list?.length > 0 &&
          block.list.map((item, index) => (
            <li key={index}>
              <Link link={item.link}>
                {item.title?.length > 0 && (
                  <span className="title">{item.title}</span>
                )}
                <span className="text-muted">{item.subtitle}</span>
              </Link>
            </li>
          ))}
      </ul>
    </TwoColWrapper>
  )
}

export default TextWithListBlock
